"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.existsByExactMpnOutputDtoSchema = exports.existsByExactMpnInputDtoSchema = exports.searchPackagesOutputDtoSchema = exports.packageSearchResultSchema = exports.searchPackagesInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const dateRangeSchema = z
    .object({
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
})
    .optional();
const sortOptionSchema = z.object({
    field: z.string(),
    direction: z.enum(['asc', 'desc']),
});
exports.searchPackagesInputDtoSchema = z
    .object({
    manufacturerId: z.string().optional(),
    packageFamilyId: z.string().optional(),
    tagIds: z.array(z.string()).optional(),
    status: z.array(z.nativeEnum(cadstrom_shared_1.PackageStatus)).optional(),
    isReviewed: z.boolean().optional(),
    sigmaModelType: z.array(z.string()).optional(),
    hasDatasheet: z.boolean().optional(),
    hasAiOutput: z.boolean().optional(),
    hasReviewedResolution: z.boolean().optional(),
    textQuery: z.string().trim().optional(),
    createdBetween: dateRangeSchema,
    pinCountMin: z.number().int().nonnegative().optional(),
    pinCountMax: z.number().int().nonnegative().optional(),
    signalCountMin: z.number().int().nonnegative().optional(),
    signalCountMax: z.number().int().nonnegative().optional(),
    packageIdIn: z.array(z.string()).optional(),
    packageIdNotIn: z.array(z.string()).optional(),
    fileIdIn: z.array(z.string()).optional(),
    sort: z.array(sortOptionSchema).optional(),
    cursor: z.string().optional(),
    limit: z.number().int().positive().max(200).optional(),
})
    .strict();
exports.packageSearchResultSchema = z.object({
    id: z.string(),
    manufacturerPartNumber: z.string(),
    manufacturerId: z.string(),
    manufacturerName: z.string(),
    packageFamilyId: z.string(),
    packageFamilyName: z.string(),
    packageFamilyOwnerId: z.string().nullable(),
    sigmaModelType: z.string(),
    status: z.nativeEnum(cadstrom_shared_1.PackageStatus).nullable(),
    isReviewed: z.boolean(),
    timeCreated: z.coerce.date(),
    ownerId: z.string().nullable(),
    hasDatasheet: z.boolean(),
});
exports.searchPackagesOutputDtoSchema = z.object({
    pkgs: exports.packageSearchResultSchema.array(),
    nextCursor: z.string().nullable(),
    hasNextPage: z.boolean(),
});
exports.existsByExactMpnInputDtoSchema = z.object({ mpn: z.string() }).strict();
exports.existsByExactMpnOutputDtoSchema = z.object({ exists: z.boolean() });
//# sourceMappingURL=search-packages.dto.js.map